import React, { useEffect, useRef,useState } from "react";
import '../blog/blog.css';
// import { Carousel } from 'antd';
import Carousel from 'react-bootstrap/Carousel'
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
// import sliderImg from '../../assets/images/Placeholder.png';
// import sliderImg1 from '../../assets/images/Placeholder3.png';
// import sliderImg2 from '../../assets/images/Placeholder1.png';
// import sliderImg3 from '../../assets/images/Placeholder3.png';
import {
  Link,
  useParams
} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { apiURL,webURL } from '../../configs'

const BlogDetailPage = () => {
  let { id } = useParams();
  // console.log(id)
  const [blog, setBlog] = useState(null)
  const [topBlogs, setTopBlogs] = useState([])
  useEffect(() => {
    window.scrollTo(0, 0);
    getBlog(id)
    getTopBlogs()
  }, [])
  useEffect(() => {
    window.scrollTo(0, 0);
    getBlog()
  }, [])

  const getBlog = (ID) => {
    fetch(apiURL + 'blogs/'+ID+'.json')
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setBlog(data);
        }
      });
  }
  const getTopBlogs = () => {
    fetch(apiURL + 'blogs/all_blogs')
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          let blogs = [];
          for(let i=0;i<5;i++) {
            if (data.blogs[i]) {
              blogs.push(data.blogs[i])
            }
          }
          setTopBlogs(blogs);
        }
      });
  }
// console.log(topBlogs)
  const slideRef = useRef(null);
  const next = () => {
    slideRef.current.slickNext();
  }
  const previous = () => {
    slideRef.current.slickPrev();
  }
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 2000,
    // pauseOnHover: true
  };
  function createMarkup() {
    return {__html: blog?.description};
  }
  
  return (
    <>
      <div className="header2">
        <Header />
      </div>
      <Carousel className="arrow_carousel contentStyle">
        <Carousel.Item className="carousel_bg_img_4">
          {/* <img src={sliderImg} style={{ width: "100%" }}></img> */}
         
        </Carousel.Item>
        <Carousel.Item className="carousel_bg_img_1">
          {/* <img src={sliderImg1} style={{ width: "100%" }}></img> */}
         
        </Carousel.Item>
        <Carousel.Item className="carousel_bg_img">
          {/* <img src={sliderImg2} style={{ width: "100%" }}></img> */}
         
        </Carousel.Item>
        <Carousel.Item className="carousel_bg_img_5">
          {/* <img src={sliderImg3} style={{ width: "100%" }}></img> */}
         
        </Carousel.Item>
      </Carousel>


      <div className="container_setting hero_blog_section mt-5">
        <div className="">
          <div style={{ position: "relative" }}>
            <img style={{ width: "100%"}} src={blog?.images[0]?.image} ></img>
            <div className="centered">
              <img src={require("../../assets/images/imgicon.svg")}></img>
            </div>
          </div>
    <h1>{blog?.title}</h1>
          {/* <p className="tag_line_blog">JANUARY 16,2016</p> */}
          {/* <p className="tag_line_blog_description"> */}
            {/* Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
             labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcos 
             laboris nisis ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
             voluptate velit esse cillum dolore egiat nulla pariatur. Excepteur sint occaecat cupidatat 
             non proident, sunt in culpa qui officia deserunt mollit anim id it laborum. Sed ut perspiciatis
              unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, 
              eaque ipsa quae ab illo inventore ut labore et dolore now is the great working with travlling magnam 
              aliquam quaerat voluptatem.<br></br><br></br>
          Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt 
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcos laboris
           nisis ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore egiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui off
            icia deserunt mollit anim id it laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem ac
            cusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore ut labore et dolore
             now is the great working with travlling magnam aliquam quaerat voluptatem. */}
             
             {/* <div  dangerouslySetInnerHtml={{__html: }} /> */}
             <div dangerouslySetInnerHTML={createMarkup()} className="tag_line_blog_description" />


          {/* </p> */}
          {/* <p style={{ textTransform: "uppercase", color: "#999999", fontSize: "13px", fontWeight: "800" }} className="mb-0 text-center">MEDICINE, COVID-19, SURGERY</p> */}
        </div>
      </div>
      <div className="container_setting hero_blog_section">
        <div className="row">
          {/* <div className="col-md-12">
            <div className="d-flex justify-content-center">
              <div className="previous_style_margin previous_style_margin_width">
                <Link to="/blog" className="text-decoration-none">
                  <section className="alert previous_style" style={{ textTransform: "uppercase",background: "#1F91D4", color: "white", textAlign: "center",  borderRadius: "10px", cursor: "pointer" }}> <img style={{ width: "14px" }} className="mr-2" src={require("../../assets/images/arrowleft.svg")}></img><span style={{ display: "inline-block" }}>PREVIOUS POST</span></section>
                </Link>
              </div>
              <div className="previous_style_margin_width">
                <Link to="/blog" className="text-decoration-none">
                  <section className="alert previous_style" style={{ textTransform: "uppercase", background: "#0078CA", color: "white", textAlign: "center", borderRadius: "10px", cursor: "pointer" }}><span style={{ display: "inline-block" }}>NEXT POST</span> <img style={{ width: "14px" }} className="ml-2" src={require("../../assets/images/arrowright.svg")}></img> </section>
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div className="container_setting hero_blog_section">
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex">
              <div>
                <h1 className="pt-0" style={{ fontSize: "17px", textTransform: "uppercase" }}>RECOMENDED POSTS</h1>
              </div>
              <div className="ml-auto icon_alignment_icon">
                <img style={{ cursor: "pointer" }} className="mr-2" src={require("../../assets/images/arrowslider.svg")} onClick={previous}></img>
                <img style={{ cursor: "pointer" }} src={require("../../assets/images/arrowslider1.svg")} onClick={next}></img>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12 blog_category_slider">
            <Slider ref={slideRef} {...settings} style={{cursor:'pointer'}}>
            {topBlogs.length && topBlogs.map((blog, i) => {
            return (
            <div key={i}>
              <a href={webURL+"blog/" + blog.id} target="_blank"> 
                {/* <h3>1</h3> */}
                <img src={blog.images[0].image} style={{ width: "100%", height: "200px" }}></img>
                <p className="mb-0 post_content">{blog.title}<br></br> </p>
                </a>
                {/* <p>  {blog.description ? blog.description.slice(0, 60) + '...' : ''}</p> */}
              </div>)
          })}
            
            </Slider>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default BlogDetailPage;